import { Component, HostListener } from '@angular/core';

import { NgIf } from '@angular/common';
import { ShHtmlParserComponent } from '../../../core/html-parser/html-parser.component';
import { ShIconComponent } from '../../../elements/components/icon/icon.component';
import { DialogConfig } from '../../entities/dialog-config.entity';
import { DialogRef } from '../../entities/dialog-ref.class';

@Component({
    selector: 'sh-boolean-dialog-component',
    templateUrl: './boolean-dialog.component.html',
    standalone: true,
    imports: [NgIf, ShIconComponent, ShHtmlParserComponent]
})
export class ShBooleanDialogComponent {
    constructor(
        public config: DialogConfig,
        public dialog: DialogRef<boolean>
    ) {}

    @HostListener('document:keydown.enter', ['$event'])
    handleEnter(event: KeyboardEvent) {
        this.yes();
    }

    yes(): void {
        this.dialog.close(true);
    }

    no(): void {
        this.dialog.close(false);
    }
}
